import Event from '~/utils/Event'

export default (state, { payload: deviceIds }) => {
  const updatedUser = { ...state.user }
  updatedUser.events = updatedUser.events.filter(event => (!deviceIds.includes(event.deviceId)))
  return { ...state, user: updatedUser }
}
